import { InjectionToken } from '@angular/core';

export const WIDGETS_B2C_API_URL = new InjectionToken<string>(
  'WIDGETS_B2C_API_URL',
);
